import { Card } from 'components/Card';
import { CardRow } from 'components/CardRow';
import { animateNext } from 'lib/animateNext';
import React from 'react';

type Props = {
  options: {
    value: string;
    label: string;
  }[];
  value: string | null;
  onChange: (value: string) => void;
};

export const ReviewStatusField: React.FC<Props> = ({
  onChange,
  options,
  value,
}) => {
  const [isEditing, setIsEditing] = React.useState(!value);

  const handleStartEdit = () => {
    animateNext();
    setIsEditing(true);
  };
  const handleChange = (newValue: string) => {
    if (value) {
      setIsEditing(false);
    }
    onChange(newValue);
  };

  if (isEditing || !value) {
    return (
      <Card
        margin={false}
        marginHorizontal={false}
        expandedInline={!!value}
        expandedInlineFirst={!!value}
      >
        {options.map((option) => (
          <CardRow
            key={option.value}
            label={option.label}
            onPress={() => handleChange(option.value)}
            radioValue={option.value === value}
          />
        ))}
      </Card>
    );
  }

  const reviewStatus = options.find((option) => option.value === value);

  return (
    <CardRow
      label="Reviewed As"
      value={reviewStatus?.label}
      onPress={handleStartEdit}
      navigationType="input-radio"
    />
  );
};
